import React, { useEffect, useState, useRef } from "react";
import {
  Typography,
  Stack,
  Box,
  Grid,
  Divider,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Checkbox,
  TextField,
} from "@mui/material";
import axios from "axios";
import { useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { ReactComponent as UploadFileIcon } from "../../../../Icons/UploadFileIcon.svg";
import { ReactComponent as ImgIcon } from "../../../../Icons/ImgIcon.svg";
import ClearIcon from "@mui/icons-material/Clear";
import { ReactComponent as FormIcon } from "../../../../Icons/CommonFormIcon.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers";
import PhoneInputController from "../../../../CommonComponents/PhoneInputController";
import { useTranslation } from "react-i18next";


export default function Agreement({selectedPackage, setSelectedPackage, setStepperCount, formData, setFormData }) {
  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    getValues,
    watch,
    setValue,
    trigger,
  } = useForm({
    mode: "onTouched",
  });

  const navigate = useNavigate();
  const data = useSelector((state) => state.AdminData.admin);
  const [allData, setAllData] = useState({});
  const [checked, setChecked] = useState(false);
  const {id} = useParams()
  const {t} = useTranslation()

  const handleNext = async () => {
    const isFormValid = await trigger();

    if (isFormValid) {
      setStepperCount(2);
    }
  };

  const Ipawatch = watch("ipa");
  const Passportwatch = watch("passport");
  const imgFile = useRef();
  const passportFile = useRef();
  const ipaFile = useRef();
  // const imgFile = useRef();

  const [bgImg, setBgImg] = useState([]);

  const language = useSelector((state) => state.language.language)

  const [dropDown, setDropDown] = useState([
    {
      id : 1,
      title : 'Guardian Service for Primary/Secondary School and International School (1 year)',
      amount : 6000
    },
    {
      id : 2,
      title : 'Guardian Service for Private University (1 year)',
      amount : 2000
    }
  ])

  // useEffect(() => {
  //   if (Boolean(Ipawatch)) {
  //     setBgImg((prev) => []);

  //     Array.from(Imgwatch)?.map((item, index) =>
  //       setBgImg((prev) => [...prev, { id: index + 1, img: item }])
  //     );
  //   }
  // }, [Imgwatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchData = async () => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}get-paiduser-by-id/${data.id}`)
      .then((response) => {
        console.log(response, "paid user");
        if (response.status === 200) {
          if (response?.data?.data.tenancyAgreement) {
            setValue("name", response?.data?.data?.tenancyAgreement.name);
            setValue(
              "passport",
              response?.data?.data?.tenancyAgreement.passport_no
            );
            setValue(
              "finnumber",
              response?.data?.data?.tenancyAgreement.fin_no
            );
            setValue("img", [response?.data?.data?.tenancyAgreement.signature]);
            setChecked(response.data.data.tenancyAgreement.agreement);
          } else {
            setValue("name", response?.data?.data?.PersonalData?.Details?.name);
            setValue(
              "passport",
              response?.data?.data?.PersonalData?.Details?.passport_no
            );
          }
          setAllData(response.data.data);
        }
      })
      .catch((error) => console.log(error));
  };

  // const fetchTenancyAgreement = async () => {
  //     await axios.get(`${process.env.REACT_APP_API_URL}get-tenancy-agreement/${data.id}`)
  //     .then((response) => {
  //       console.log(response)
  //     }).catch((error) => {
  //       console.log(error)
  //     })
  // }

  // useEffect(() => {
  //   if (data?.id) {
  //     fetchData();
  //   }
  // }, []);

  const handleChange = () => {
    setChecked(!checked);
  };

  useEffect(() => {
    setValue('name', formData?.name)
    setValue('phone', formData?.phone)
    setValue('email', formData?.email)
    setValue('line', formData?.line)
    setValue('wechat', formData?.wechat)
    setValue('whatsapp', formData?.whatsapp)
    setValue('schoolAttended', formData?.schoolAttended)
    setValue('gradeYearOfStudy', formData?.gradeYearOfStudy)
    setValue('guardianPackage', formData?.guardianPackage)
    setValue('passport', formData?.passport)
    setValue('ipa', formData?.ipa)
  }, [formData])

  const onSubmit = async (dataa) => {
    console.log(dataa, 'form data');
    setFormData(dataa)
    handleNext()
    // const sendObj = new FormData();
    // sendObj.append("name", dataa?.name);
    // sendObj.append("fin_no", dataa?.finnumber);
    // sendObj.append("passport_no", dataa?.passport);
    // sendObj.append("signature", dataa?.img[0]);
    // sendObj.append("agreement", checked);
    // await axios
    //   .put(
    //     `${process.env.REACT_APP_API_URL}add-tenancy-agreement/${data.id}`,
    //     sendObj,
    //     {
    //       headers: {
    //         "Content-Type": "multipart/form-data",
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     console.log(response);
    //     if (response.status == 200) {
    //       setStepperCount(2);
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  };

  const deleteIpa = (id) => {
    let updatedFiles = Array.from(Ipawatch);
    updatedFiles = updatedFiles.filter((file, index) => index !== id);
    setValue("ipa", updatedFiles);
  };
  const deletePassport = (id) => {
    let updatedFiles = Array.from(Passportwatch);
    updatedFiles = updatedFiles.filter((file, index) => index !== id);
    setValue("passport", updatedFiles);
  };

  return (
    <Box px={{ md: 10, xs: 3 }}>
      <form onSubmit={handleSubmit(onSubmit)}>
      <Box>
          <Typography sx={{ fontSize: "24px" }}>
            {t("Personal Information")}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            mt: 2,
            gap: 2,
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ width: {xs : '100%', md : "45%"}}}>
            <InputLabel
              sx={{
                mt: 2,
                mb: 1,
                fontSize: "18px",
                fontWeight: 600,
                color: "black",
              }}
            >
              {errors?.name ? `${t("name")}*` : `${t("name")}*`}
            </InputLabel>
            <Controller
              name="name"
              control={control}
              rules={{ required: "Name is required",
              maxLength: {
                value: 50,
                message: "Name cannot exceed 50 characters"
              } }}
              render={({ field }) => (
                <TextField
                  placeholder="Enter name"
                  error={Boolean(errors?.name) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.name ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.name
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.name
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.name
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                />
              )}
            />
            {errors?.name ? (
              <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                {errors?.name?.message}
              </Typography>
            ) : null}
          </Box>

          <Box sx={{ width: {xs : '100%', md : "45%"}}}>
            <InputLabel
              sx={{
                mt: 2,
                mb: 1,
                fontSize: "18px",
                fontWeight: 600,
                color: "black",
              }}
            >
              {errors?.phone ? `${t("Phone")}*` : `${t("Phone")}*`}
            </InputLabel>
            <PhoneInputController
        name="phone"
        control={control}
        rules={{ required: 'Phone number is required' }}
      />
            {errors?.phone ? (
              <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                {errors?.phone?.message}
              </Typography>
            ) : null}
          </Box>

          <Box sx={{ width: {xs : '100%', md : "45%"}}}>
            <InputLabel
              sx={{
                mt: 2,
                mb: 1,
                fontSize: "18px",
                fontWeight: 600,
                color: "black",
              }}
            >
              {errors?.email ? `${t("email")}*` : `${t("email")}*`}
            </InputLabel>
            <Controller
              name="email"
              control={control}
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Enter a valid email address",
                },
              }}
              render={({ field }) => (
                <TextField
                  placeholder="Enter email"
                  error={Boolean(errors?.email) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.email ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.email
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.email
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.email
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                />
              )}
            />
            {errors?.email ? (
              <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                {errors?.email?.message}
              </Typography>
            ) : null}
          </Box>
        </Box>

        <Divider sx={{ mt: 4, mb: 4 }} />

        <Box>
          <Typography sx={{ fontSize: "24px" }}>{t("Contact Preferences")}</Typography>
          <Divider sx={{ mt: 2, mb: 2 }} />

          <Box
            sx={{
              display: "flex",
              mt: 2,
              gap: 2,
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ width: {xs : '100%', md : "45%"}}}>
              <InputLabel
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                {errors?.line ? `${t("line")}*` : `${t("line")}*`}
              </InputLabel>
              <Controller
              name="line"
              control={control}
              rules={{ required: "LINE is required",
              maxLength: {
                value: 70,
                message: "LINE cannot exceed 70 characters"
              } }}
              render={({ field }) => (
                <TextField
                  placeholder="Enter line"
                  error={Boolean(errors?.line) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.line ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.line
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.line
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.line
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                />
              )}
            />
              {errors?.line ? (
                <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                  {errors?.line?.message}
                </Typography>
              ) : null}
            </Box>

            <Box sx={{ width: {xs : '100%', md : "45%"}}}>
              <InputLabel
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                {errors?.wechat ? `${t("wechat")}*` : `${t("wechat")}*`}
              </InputLabel>
              <Controller
              name="wechat"
              control={control}
              rules={{ required: "WeChat is required",
              maxLength: {
                value: 70,
                message: "WeChat cannot exceed 70 characters"
              } }}
              render={({ field }) => (
                <TextField
                  placeholder="Enter wechat"
                  error={Boolean(errors?.wechat) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.wechat ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.wechat
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.wechat
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.wechat
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                />
              )}
            />
              {errors?.wechat ? (
                <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                  {errors?.wechat?.message}
                </Typography>
              ) : null}
            </Box>

            <Box sx={{ width: {xs : '100%', md : "45%"}}}>
              <InputLabel
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                {errors?.whatsapp ? `${t("whatsapp")}*` : `${t("whatsapp")}*`}
              </InputLabel>
              <Controller
              name="whatsapp"
              control={control}
              rules={{ required: "WhatsApp is required",
              maxLength: {
                value: 70,
                message: "WhatsApp cannot exceed 70 characters"
              } }}
              render={({ field }) => (
                <TextField
                  placeholder="Enter whatsapp"
                  error={Boolean(errors?.whatsapp) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.whatsapp ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.whatsapp
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.whatsapp
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.whatsapp
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                />
              )}
            />
              {errors?.whatsapp ? (
                <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                  {errors?.whatsapp?.message}
                </Typography>
              ) : null}
            </Box>
          </Box>
        </Box>

        <Divider sx={{ mt: 4, mb: 2 }} />

        <Box>
          <Typography sx={{ fontSize: "24px" }}>{t("Education Details")}</Typography>
        </Box>

        <Box sx={{ display: "flex", mt: 2, justifyContent: "space-between", flexWrap : 'wrap', gap : 2 }}>
          <Box sx={{ width: {xs : '100%', md : "45%"}}}>
            <InputLabel
              sx={{
                mb: 1,
                fontSize: "18px",
                fontWeight: 600,
                color: "black",
              }}
            >
              {errors?.schoolAttended ? `${t("School Attended")}*` : `${t("School Attended")}*`}
            </InputLabel>
            <Controller
              name="schoolAttended"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  placeholder="Enter School Attended"
                  error={Boolean(errors?.schoolAttended) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.schoolAttended ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.schoolAttended
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.schoolAttended
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.schoolAttended
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                />
              )}
            />
            {errors?.schoolAttended ? (
              <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                Please enter school attended
              </Typography>
            ) : null}
          </Box>

          <Box sx={{ width: {xs : '100%', md : "45%"}}}>
            <InputLabel
              sx={{
                mb: 1,
                fontSize: "18px",
                fontWeight: 600,
                color: "black",
              }}
            >
              {errors?.gradeYearOfStudy
                ? `${t("Grade/Year of Study")}*`
                : `${t("Grade/Year of Study")}*`}
            </InputLabel>
            <Controller
              name="gradeYearOfStudy"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  placeholder="Enter grade/year of study"
                  error={Boolean(errors?.gradeYearOfStudy) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.gradeYearOfStudy ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.gradeYearOfStudy
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.gradeYearOfStudy
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.gradeYearOfStudy
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                />
              )}
            />
            {errors?.gradeYearOfStudy ? (
              <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                Please enter grade/ year of study
              </Typography>
            ) : null}
          </Box>
        </Box>

        <Divider sx={{ mt: 4, mb: 2 }} />

        <Box>
          <Typography sx={{ fontSize: "24px" }}>{t("Guardian Package")}</Typography>
        </Box>

        <Box sx={{ display: "flex", mt: 2, justifyContent: "space-between",flexWrap : 'wrap', gap : 2 }}>
          <Box sx={{ width: {lg : "45%", xs : '100%'} }}>
            <InputLabel
              sx={{
                mb: 1,
                fontSize: "18px",
                fontWeight: 600,
                color: "black",
              }}
            >
              {errors?.guardianPackage
                ? `${t("Guardian Package")}*`
                : `${t("Guardian Package")}*`}
            </InputLabel>
            <Controller
              name="guardianPackage"
              control={control}
              defaultValue="0"
              rules={{
                required : "Guardian package is required!",
                validate: (value) => value !== "0" || "Please select a valid guardian package"
              }}
              render={({ field }) => (
                <Select
                  placeholder="Enter Guardian Package"
                  error={Boolean(errors?.guardianPackage) ? true : false}
                  {...field}
                  sx={{
                    width: "100%",
                    backgroundColor: "rgb(249, 250, 251)",
                    borderRadius: 0,
                    "& .MuiInputBase-input": {
                      color: errors?.guardianPackage ? "red" : "black",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: errors?.guardianPackage
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: errors?.guardianPackage
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: errors?.guardianPackage
                          ? "#ff5e74"
                          : "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                >
                  <MenuItem value="0">
                    <em>{t("Select Guardian Package")}</em>
                  </MenuItem>
                  {dropDown.map((drop) => (
                    <MenuItem sx={{ whiteSpace: "normal" }} onClick={() => setSelectedPackage(drop)} key={drop.id} value={drop.id}>{`${t(drop.title)} S$ ${drop.amount}`}</MenuItem>
                  ))}
                </Select>
              )}
            />
            {errors?.guardianPackage ? (
              <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                Please enter guardian package
              </Typography>
            ) : null}
          </Box>
        </Box>

        <Divider sx={{ mt: 4, mb: 2 }} />

        <Box>
          <Typography sx={{ fontSize: "24px" }}>{t("Upload")}</Typography>
        </Box>

        <Box sx={{ mt: 2 }}>
          <Box sx={{ width: "100%" }}>
            <InputLabel
              sx={{
                mb: 1,
                fontSize: "18px",
                fontWeight: 600,
                color: "black",
              }}
            >
              {errors?.passport
                ? `${t("Upload Passport ID Page")}*`
                : `${t("Upload Passport ID Page")}*`}
            </InputLabel>

            {Boolean(Passportwatch?.length > 0) ? (
              Array.from(Passportwatch)?.map((item, index) => (
                <Box style={{ padding: "0px 17px 17px" }}>
                  <Stack
                    mt={2}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    padding="23px"
                    borderRadius="8px"
                    sx={{ border: ".5px solid #1A2461" }}
                  >
                    <Typography
                      variant="h9_1"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <ImgIcon />
                      {item?.name || item?.originalname}
                    </Typography>
                    <ClearIcon
                      onClick={() => deletePassport(index)}
                      sx={{ color: "#1A2461" }}
                    />
                  </Stack>
                </Box>
              ))
            ) : (
              <Box
                xs={12}
                onClick={() => passportFile.current.click()}
                sx={{
                  border: Boolean(errors.passport)
                    ? "1px dashed red"
                    : "1px dashed #1A2461",
                  height: "200px",
                  borderRadius: "8px",
                  backgroundColor: "#F9FBFF",
                  margin: "20px 17px 17px",
                }}
              >
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  height="100%"
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      height: "100px",
                      width: "100px",
                      borderRadius: "100px",
                      backgroundColor: "#F2F2F2",
                    }}
                  >
                    <UploadFileIcon fill="#1A2461" />
                  </Stack>
                  <Stack mt={2} direction="row" alignItems="center" gap="5px">
                    <Typography variant="h9_1">{t("Click to upload")}</Typography>
                  </Stack>
                  <Typography variant="h9_5">{t("Allowed formats")} - PDF, PNG, JPG</Typography>
                </Stack>
              </Box>
            )}

            {errors?.passport ? (
              <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                Please upload passport id page
              </Typography>
            ) : null}
          </Box>

          <Box sx={{ width: "100%" }}>
            <InputLabel
              sx={{
                mb: 1,
                fontSize: "18px",
                fontWeight: 600,
                color: "black",
              }}
            >
              {errors?.ipa
                ? `${t("Upload IPA Letter")}`
                : `${t("Upload IPA Letter")}`}
            </InputLabel>

            {Boolean(Ipawatch?.length > 0) ? (
              Array.from(Ipawatch)?.map((item, index) => (
                <Box style={{ padding: "0px 17px 17px" }}>
                  <Stack
                    mt={2}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    padding="23px"
                    borderRadius="8px"
                    sx={{ border: ".5px solid #1A2461" }}
                  >
                    <Typography
                      variant="h9_1"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <ImgIcon />
                      {item?.name || item?.originalname}
                    </Typography>
                    <ClearIcon
                      onClick={() => deleteIpa(index)}
                      sx={{ color: "#1A2461" }}
                    />
                  </Stack>
                </Box>
              ))
            ) : (
              <Box
                xs={12}
                onClick={() => ipaFile.current.click()}
                sx={{
                  border: Boolean(errors.ipa)
                    ? "1px dashed red"
                    : "1px dashed #1A2461",
                  height: "200px",
                  borderRadius: "8px",
                  backgroundColor: "#F9FBFF",
                  margin: "20px 17px 17px",
                }}
              >
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  height="100%"
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      height: "100px",
                      width: "100px",
                      borderRadius: "100px",
                      backgroundColor: "#F2F2F2",
                    }}
                  >
                    <UploadFileIcon fill="#1A2461" />
                  </Stack>
                  <Stack mt={2} direction="row" alignItems="center" gap="5px">
                    <Typography variant="h9_1">{t("Click to upload")}</Typography>
                  </Stack>
                  <Typography variant="h9_5">{t("Allowed format")} - PDF, PNG, JPG</Typography>
                </Stack>
                <Box sx={{ marginTop: "0.3rem" }}>
                  {errors?.ipa ? (
                    <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                      Please upload a PDF file
                    </Typography>
                  ) : null}
                </Box>
              </Box>
            )}
            <Controller
              name="ipa"
              rules={{ required: false }}
              control={control}
              render={({ field }) => (
                <input
                  type="file"
                  accept="image/*,application/pdf"
                  onChange={(e) => {
                    field.onChange(e.target.files);
                  }}
                  ref={(e) => {
                    ipaFile.current = e;
                  }}
                  hidden
                  multiple
                />
              )}
            />
            <Controller
              name="passport"
              rules={{ required: true }}
              control={control}
              render={({ field }) => (
                <input
                  type="file"
                  accept="image/*,application/pdf"
                  onChange={(e) => {
                    field.onChange(e.target.files);
                  }}
                  ref={(e) => {
                    passportFile.current = e;
                  }}
                  hidden
                  multiple
                />
              )}
            />
          </Box>

          <Box
        sx={{ mt: 6, mb: 6, display: "flex", justifyContent: "space-between" }}
      >
        <Button
        onClick={()=> navigate(`/services/${id}`)}
          variant="standard"
        >
          {t("Back")}
        </Button>
        <Button
          type="submit"
          // onClick={handleNext}
          variant="standard"
        >
          {t("Continue")}
        </Button>
      </Box>
        </Box>
      </form>

      
    </Box>
  );
}
